import { ONBOARDING_POLL_OPTION_FAIRLY_DIFFICULT, ONBOARDING_POLL_OPTION_FAIRLY_EASY, ONBOARDING_POLL_OPTION_STANDARD, ONBOARDING_POLL_OPTION_VERY_DIFFICULT, ONBOARDING_POLL_OPTION_VERY_EASY } from './cdn-assets';
export const ONBOARDING_POLL_OPTIONS = [
    {
        value: 'Very Difficult',
        icon: ONBOARDING_POLL_OPTION_VERY_DIFFICULT
    },
    {
        value: 'Fairly Difficult',
        icon: ONBOARDING_POLL_OPTION_FAIRLY_DIFFICULT
    },
    {
        value: 'Standard',
        icon: ONBOARDING_POLL_OPTION_STANDARD
    },
    {
        value: 'Fairly Easy',
        icon: ONBOARDING_POLL_OPTION_FAIRLY_EASY
    },
    {
        value: 'Very Easy',
        icon: ONBOARDING_POLL_OPTION_VERY_EASY
    }
];
